import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import LoadingProgressReducer from "../components/basic/LoadingProgress/loadingProgressSlice";
import NotificationBarReducer from "../components/basic/NotificationBar/notificationBarSlice";
import CheckoutInfoReducer from "../pages/CheckoutInfo/checkoutInfoSlice";
import CheckoutPaymentReducer from "../pages/CheckoutPayment/checkoutPaymentSlice";
import AddressReducer from "components/Address/store/addressSlice";
import AuthReducer from "@/core/store/authSlice";

const preloadedState = window.__PRELOADED_STATE__;

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    loadingProgress: LoadingProgressReducer,
    notification: NotificationBarReducer,
    checkoutInfo: CheckoutInfoReducer,
    checkoutPayment: CheckoutPaymentReducer,
    address: AddressReducer,
    auth: AuthReducer,
  },
  preloadedState,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
